import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SpaceConfigOptionsService } from '../../services/space-config-options.service';
import { inject } from '@angular/core';

@Component({
    selector: 'app-company-profile',
    imports: [TranslateModule],
    templateUrl: './company-profile.component.html',
    styleUrl: './company-profile.component.scss'
})
export class CompanyProfileComponent {
  private readonly spaceConfigOptions = inject(SpaceConfigOptionsService);

  get industries() { return this.spaceConfigOptions.industries; }
  get disciplines() { return this.spaceConfigOptions.disciplines; }
  get materials() { return this.spaceConfigOptions.materials; }

  @Input() set selectedIndustries(val: string[]) { this._selectedIndustries = val ?? []; }
  get selectedIndustries(): string[] { return this._selectedIndustries; }
  private _selectedIndustries: string[] = [];

  @Input() set selectedDisciplines(val: string[]) { this._selectedDisciplines = val ?? []; }
  get selectedDisciplines(): string[] { return this._selectedDisciplines; }
  private _selectedDisciplines: string[] = [];

  @Input() set selectedMaterials(val: string[]) { this._selectedMaterials = val ?? []; }
  get selectedMaterials(): string[] { return this._selectedMaterials; }
  private _selectedMaterials: string[] = [];

  @Output() selectedIndustriesChange = new EventEmitter<string[]>();
  @Output() selectedDisciplinesChange = new EventEmitter<string[]>();
  @Output() selectedMaterialsChange = new EventEmitter<string[]>();

  toggleIndustry(industry: string): void {
    const index = this.selectedIndustries.indexOf(industry);
    if (index === -1) {
      this.selectedIndustries = [...this.selectedIndustries, industry];
    } else {
      this.selectedIndustries = this.selectedIndustries.filter(i => i !== industry);
    }
    this.selectedIndustriesChange.emit(this.selectedIndustries);
  }

  isIndustrySelected(industry: string): boolean {
    return this.selectedIndustries.includes(industry);
  }

  toggleDiscipline(discipline: string): void {
    const index = this.selectedDisciplines.indexOf(discipline);
    if (index === -1) {
      this.selectedDisciplines = [...this.selectedDisciplines, discipline];
    } else {
      this.selectedDisciplines = this.selectedDisciplines.filter(d => d !== discipline);
    }
    this.selectedDisciplinesChange.emit(this.selectedDisciplines);
  }

  isDisciplineSelected(discipline: string): boolean {
    return this.selectedDisciplines.includes(discipline);
  }

  toggleMaterial(material: string): void {
    const index = this.selectedMaterials.indexOf(material);
    if (index === -1) {
      this.selectedMaterials = [...this.selectedMaterials, material];
    } else {
      this.selectedMaterials = this.selectedMaterials.filter(m => m !== material);
    }
    this.selectedMaterialsChange.emit(this.selectedMaterials);
  }

  isMaterialSelected(material: string): boolean {
    return this.selectedMaterials.includes(material);
  }

  getIndustryImagePath(industryId: string): string {
    const imageMap: { [key: string]: string } = {
      'building-design': 'assets/images/building-design.png',
      'infrastructure-design': 'assets/images/infrastructure-design.png',
      'construction-planning': 'assets/images/construction-planning.png'
    };
    return imageMap[industryId] || '';
  }
}
